import { formatDateFromSF } from "@/helpers";

export function formatVoting(item) {
  const date = formatDateFromSF(item.Fecha__c);
  return {
    nombre: `${item.Iniciativa__r?.Name || ""} (${item.Name || ""})`,
    subject: item.Iniciativa__r?.Tema__c,
    accountName: item.Establecimiento__r?.Name,
    ...item,
    date,
    timestamp: date?.getTime() || 0,
  };
}

export function prepareVotings(votings = {}) {
  for (let key in votings) {
    votings[key] = formatVoting(votings[key]);
  }
  return votings;
}
